var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left"},[_c('v-pagination',{attrs:{"length":_vm.pageCount,"total-visible":11},on:{"input":_vm.getNumber},model:{value:(_vm.selectPage),callback:function ($$v) {_vm.selectPage=$$v},expression:"selectPage"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }